var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "communication/outline/mail_arrow right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 2.5L21.7929 3.79289C22.1834 4.18342 22.1834 4.81658 21.7929 5.20711L20.5 6.5M16.5 4.5H21.5M6.5 13.5L8.7 15.15C9.76667 15.95 11.2333 15.95 12.3 15.15L14.5 13.5M5.5 22.5H15.5C17.1569 22.5 18.5 21.1569 18.5 19.5V11.5C18.5 9.84315 17.1569 8.5 15.5 8.5H5.5C3.84315 8.5 2.5 9.84315 2.5 11.5V19.5C2.5 21.1569 3.84315 22.5 5.5 22.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail_arrow_right.2d4391db789d6bf8a83ac12e09671e44.svg";